<template>
  <a-steps
    class="style-step"
    :current="current - 0"
    size="small"
    :status="status"
  >
    <a-step v-for="i in currentList" :title="i.name" :key="i.name" />
    <!-- <a-step title="个人申报" />
    <a-step title="用人单位审核" />
    <a-step v-if="isProvincialUnit == 0" title="主管单位审核" />
    <a-step title="市委组织部审核" />
    <a-step title="面试" />
    <a-step title="体检" />
    <a-step title="考察" />
    <a-step title="结果公示" /> -->
  </a-steps>
</template>

<script>
export default {
  name: 'ComSteps',
  props: {
    // isProvincialUnit: {
    //   type: [Number, Boolean] ////0上一级为主管单位 ， 1上一级为市委组织部 。。。0就是非省属，1省属
    // },
    completeSelection:{
      type:[Number,String],
      default:0
    },
    bfStateName: {
      type: String
    },
  },
  data() {
    return {
      current: 0,
      status: 'wait',
      personStepList: [
        {
          name: '个人申报',
          state: 'RETURN_FOR_MODIFICATION,DRAFT',
          errorState: 'CANCELED'
        },
        {
          name: '资格审核',
          state: 'EMPLOYERS_REVIEW,UPLOAD_MATERIALS,EMPLOYERS_MATERIALS_REVIEW,HEAD_UNITS_REVIEW,OD_REVIEW,EMPLOYERS_INTERVIEW,HEAD_UNITS_INTERVIEW,EMPLOYERS_INTERVIEW_AGAIN,PRE_HIRE,HIRE,HEALTH_CHECKUP,HEALTH_CHECKUP_NO_PASS,EMPLOYERS_INTERVIEW_NO_PASS,EMPLOYERS_INTERVIEW_AGAIN_NO_PASS,HEAD_UNITS_INTERVIEW_NO_PASS,PRE_HIRE_NO_PASS',
          errorState: 'EMPLOYERS_NO_PASS,EMPLOYERS_MATERIALS_NO_PASS,HEAD_UNITS_NO_PASS,OD_REVIEW_NO_PASS'
        },
        {
          name: '申报结果',
          state:'',
          errorState:
            'HIRED_CANCEL,HIRE_NO_PASS',
          finishState: 'HIRED,HIRED_WAIT_CHECKUP'
        }
      ],
      // 个人已完成选拔的 讲‘资格审核’中state包含不通过状态的提到 ‘申报结果’的errorState中
      personStepListFinish: [
        {
          name: '个人申报',
          state: 'RETURN_FOR_MODIFICATION,DRAFT',
          errorState: 'CANCELED'
        },
        {
          name: '资格审核',
          state: 'EMPLOYERS_REVIEW,UPLOAD_MATERIALS,EMPLOYERS_MATERIALS_REVIEW,HEAD_UNITS_REVIEW,OD_REVIEW,EMPLOYERS_INTERVIEW,HEAD_UNITS_INTERVIEW,EMPLOYERS_INTERVIEW_AGAIN,PRE_HIRE,HIRE,HEALTH_CHECKUP',
          errorState: 'EMPLOYERS_NO_PASS,EMPLOYERS_MATERIALS_NO_PASS,HEAD_UNITS_NO_PASS,OD_REVIEW_NO_PASS'
        },
        {
          name: '申报结果',
          state:'',
          errorState:
            'HIRED_CANCEL,HIRE_NO_PASS,HEALTH_CHECKUP_NO_PASS,EMPLOYERS_INTERVIEW_NO_PASS,EMPLOYERS_INTERVIEW_AGAIN_NO_PASS,HEAD_UNITS_INTERVIEW_NO_PASS,PRE_HIRE_NO_PASS',
          finishState: 'HIRED,HIRED_WAIT_CHECKUP'
        }
      ],
      stepsList: [
        {
          name: '个人申报',
          state: 'RETURN_FOR_MODIFICATION,DRAFT',
          errorState: 'RETURN_FOR_MODIFICATION,CANCELED'
        },
        {
          name: '用人单位审核',
          state: 'EMPLOYERS_REVIEW,UPLOAD_MATERIALS,EMPLOYERS_MATERIALS_REVIEW',
          errorState: 'EMPLOYERS_NO_PASS,EMPLOYERS_MATERIALS_NO_PASS'
        },
        {
          name: '主管单位审核',
          state: 'HEAD_UNITS_REVIEW',
          errorState: 'HEAD_UNITS_NO_PASS'
        },
        {
          name: '市委组织部审核',
          state: 'OD_REVIEW',
          errorState: 'OD_REVIEW_NO_PASS'
        },
        {
          name: '初步面试',
          state: 'EMPLOYERS_INTERVIEW,EMPLOYERS_INTERVIEW_AGAIN',
          errorState: 'EMPLOYERS_INTERVIEW_NO_PASS,EMPLOYERS_INTERVIEW_AGAIN_NO_PASS'
        },
        {
          name: '面试',
          state: 'HEAD_UNITS_INTERVIEW',
          errorState: 'HEAD_UNITS_INTERVIEW_NO_PASS'
        },
        {
          name: '体检（考察）',
          state: 'HEALTH_CHECKUP',
          errorState: 'HEALTH_CHECKUP_NO_PASS'
        },
        {
          name: '拟录用',
          state: 'PRE_HIRE',
          errorState: 'PRE_HIRE_NO_PASS'
        },
        {
          name: '完成选拔',
          state: 'HIRE',
          errorState: 'HIRED_CANCEL,HIRE_NO_PASS',
          finishState: 'HIRED,HIRED_WAIT_CHECKUP'
        }
      ]
    };
  },
  computed: {
    isPersonal() {
      //用人端还是单位端
      if (this.$route.path.includes('institution')) {
        return false;
      } else return true;
    },
    currentList() {
      if(!this.isPersonal){ //单位的步骤条
        return this.stepsList;
      }else if(Number(this.completeSelection)==1){
        return this.personStepListFinish; //个人已完成选拔的步骤条
      }else return this.personStepList; //未完成选拔的步骤条
      // return this.isPersonal ? this.personStepList : this.stepsList;
    }
  },
  watch: {
    bfStateName: {
      handler(val) {
        console.log('c');
        console.log(val);
        this.setSteps(val);
      }
    },
  },
  methods: {
    setSteps(state) {
      // 查找当前步骤
      let index = this.currentList.findIndex(
        i =>
          i.state.split(',').find(e => e == state) ||
          i.errorState.split(',').find(e => e == state) ||
          (i.finishState && i.finishState.split(',').find(e => e == state))
      );
      // 设置当前步骤
      this.setStepIndex(index >= 0 ? index : 0);
      // 设置当前节点的状态
      let current = this.currentList[index];
      if(current.errorState.split(',').find(e => e == state)){
        this.setCurrentStatus('error');
      }else if(current.finishState && current.finishState.split(',').find(e => e == state)){
        this.setCurrentStatus('finish');
      }else{
        this.setCurrentStatus('process');
      }
    },
    setCurrentStatus(status) {
      this.status = status;
    },
    setStepIndex(current) {
      this.current = current;
    }
  }
};
</script>

<style lang="less" scoped>
/* 步骤条样式 */
::v-deep {
  .style-step .ant-steps-item-process .ant-steps-item-icon {
    background-color: #166db3;
    border: none;
  }

  .style-step
    .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title::after {
    background-color: #146cb7;
  }

  .style-step .ant-steps-item-finish .ant-steps-item-icon {
    background-color: #ecfbff;
    border: none;
  }

  .style-step
    .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title,
  .style-step
    .ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title {
    color: #111111;
    font-size: 14px;
    font-weight: 400;
    font-family: 'PingFang SC';
  }

  .style-step .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
    color: #146cb7;
  }

  .style-step .ant-steps-item-error .ant-steps-item-icon > .ant-steps-icon {
    color: #ff000d;
  }
}
::v-deep {
  .ant-steps-item {
    flex: auto;
    margin-right: 5px!important;
    padding-right: 15px!important;

    &:last-child {
      padding-right: 0px;
    }
  }
  .ant-steps-item-title{
    padding-right: 5px!important;
  }
  // 步骤
  .ant-steps-item-wait .ant-steps-item-icon {
    border: none;
    background-color: #f1f5f8;
    color: #7a8591;
  }
}
</style>
